import { Form, Table, Button, Card, Badge, Select, FormInstance } from 'antd';
import { DeleteOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import DataSelect from '../Types/DataSelect';
import ParamsPicklist from '../Types/ParamsPicklist';
import Datas from "../Data/Data.json";
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import { Crypter } from '../Functions/Security/Crypter';
import axios from 'axios';
import { useState, useEffect } from 'react';

interface Props {
  form: FormInstance;
  disabled?: boolean;
  Size: any;
  label: string;
  name: string;
  width?: number;
  widthl?: number;
  Option?: DataSelect[];
  onchange?: any;
  notRequired?: true;
  Parametre?: ParamsPicklist;
  DefaulValue?: any;
}

const SelectMultipleOptionPanier = (props: Props) => {

  const notR = props.notRequired ? false : true;
  const authHeader = useAuthHeader();

  const [Load, setLoad] = useState(false);
  const [Data, SetData] = useState<DataSelect[]>(
    props.Option ? props.Option : []
  );

  // IMPORTANT :
  // La valeur vient directement du formulaire
  const SelectedValues: string[] =
    Form.useWatch(props.name, props.form) ||
    props.DefaulValue ||
    [];

  const LoaData = async () => {

    const datat: DataSelect[] = [];

    setLoad(true);

    const data = {
      CodeAgence: props.Parametre?.CodeAgence,
      Table: props.Parametre?.Table,
      Colonne1: props.Parametre?.Colonne1,
      Colonne2: props.Parametre?.Colonne2,
      Colagence: props.Parametre?.Colagence,
      Init: props.Parametre?.Init,
      choix: props.Parametre?.Choix,
      colfiltre: props.Parametre?.colfiltre,
      valfiltre: props.Parametre?.valfiltre
    };

    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };

    await axios(config)
      .then((response) => {

        if (response.data) {

          const res = JSON.parse(
            Crypter.decrypt(response.data)
          ).Value;

          if (res.StatutCode === 200) {

            const datas = res.Result.Table;

            if (datas.length > 0) {

              datas.forEach((item: any) => {

                datat.push({
                  value: item[Object.keys(item)[1]],
                  label:
                    item[Object.keys(item)[1]] +
                    '--' +
                    item[Object.keys(item)[0]]
                });

              });

              SetData(datat);
            }
          }
        }

        setLoad(false);

      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
      });
  };

  useEffect(() => {
    if (Data.length === 0) {
      LoaData();
    }
  }, []);

  const handleChange = (values: string[]) => {

    props.form.setFieldsValue({
      [props.name]: values
    });

    props.onchange?.(values);
  };

  const handleRemove = (value: string) => {

    const newValues = SelectedValues.filter(
      (v) => v !== value
    );

    props.form.setFieldsValue({
      [props.name]: newValues
    });

    props.onchange?.(newValues);
  };

  const selectedData = Data
    .filter((d) => SelectedValues.includes(d.value))
    .map((d, index) => ({
      key: d.value,
      id: index + 1,
      label: d.label,
      value: d.value
    }));

  const selectedColumns = [
    {
      title: '#',
      key: 'id',
      width: 50,
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Élément sélectionné',
      dataIndex: 'label',
      key: 'label',
      render: (text: string) => (
        <span
          style={{
            fontSize: '13px',
            // color: '#2e3031',
            fontWeight: '500'
          }}
        >
          ✓ {text}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: 80,
      align: 'center' as const,
      render: (_: any, record: any) => (
        <Button
          type="text"
          danger
          disabled={props.disabled}
          size="small"
          icon={<DeleteOutlined />}
          onClick={() => handleRemove(record.value)}
          style={{ padding: 0 }}
        />
      ),
    },
  ];

  return (
    <>
      <Form.Item
        label={props.label}
        name={props.name}
        initialValue={props.DefaulValue}
        className='bordure'
         preserve={true}
        rules={[
          {
            required: notR,
            message: '!'
          }
        ]}
        labelCol={{
          span: props.width,
          offset: props.widthl,
          style: { whiteSpace: 'pre-wrap' }
        }}
      >
        <Select
          mode="multiple"
          maxTagCount={0}
          size={props.Size}
          loading={Load}
          showSearch
          placeholder="Sélectionner des éléments..."
          optionFilterProp="children"
          onChange={handleChange}
          value={SelectedValues}
          disabled={props.disabled}
          options={Data}
          style={{ width: '100%' }}
          filterOption={(inputValue, option) =>
            option!.label
              .toUpperCase()
              .includes(inputValue.toUpperCase()) ||
            option!.value
              .toUpperCase()
              .includes(inputValue.toUpperCase())
          }
        />
      </Form.Item>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        {SelectedValues.length > 0 && (
          <Card
            title={
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#0050b3'
                }}
              >
                <ShoppingCartOutlined
                  style={{ marginRight: '8px' }}
                />
                Panier de sélections
              </span>
            }
            extra={
              <Badge
                count={SelectedValues.length}
                style={{
                  // backgroundColor: '#4e5358'
                }}
              />
            }
          >
            <Table
              columns={selectedColumns}
              dataSource={selectedData}
              pagination={
                SelectedValues.length > 5
                  ? { pageSize: 5, size: 'small' }
                  : false
              }
              size="small"
              rowKey="key"
            />
          </Card>
        )}
      </div>
    </>
  );
};

export default SelectMultipleOptionPanier;